import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';


// ---- Suppress ResizeObserver warning ----
const resizeObserverError = 'ResizeObserver loop completed with undelivered notifications';

const originalError = console.error;
console.error = (...args: any[]) => {
  if (args?.[0]?.toString?.().includes(resizeObserverError)) {
    return;
  }
  originalError(...args);
};

window.addEventListener('error', (event) => {
  if (event.message === resizeObserverError) {
    event.stopImmediatePropagation();
  }
});


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
